import ReactPlayer from 'react-player';
import "highlight.js/styles/tomorrow-night-bright.css";
import hljs from "highlight.js";
import { ChatDataProps } from '../../../types/backend/SengiLabsTypes';
import React, { useEffect, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'; //direkte Unterstützung für Fußnoten, Durchstreichungen, Tabellen, Aufgabenlisten und URLs
import rehypeKatex from 'rehype-katex'; //um Mathematik darzustellen
import remarkMath from 'remark-math'; //Mathematik in Markdown zu unterstützen
import rehypeRaw from 'rehype-raw'; // HTML in markdown
import rehypeStringify from 'rehype-stringify';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import rehypeFormat from 'rehype-format';
import remarkEmoji from 'remark-emoji'; //display short cut emojis
import remarkCollapse from 'remark-collapse'; //not directly typed, make collapsable sections
import mermaid from "mermaid";
import { SengiColors } from '../../../utils/SengiColors';
import { ChatComponentProps } from '../../../types/chat';

export const ChatComponent = ({
    id,
    items,
    codeStyleClass,
    componentClass,
    imageAltProp,
    imageClass,
    imageHeight,
    imageWidth,
    pdfHeight,
    pdfWidth,
    textClass,
    videoControlls,
    videoHeight,
    videoWidth
}:ChatComponentProps) =>{

    useEffect(() => {
        hljs.highlightAll();
        mermaid.initialize({ 
            startOnLoad: true,
            // theme: "default",//base, dark,default,forest,neutral
            securityLevel: "loose",
            //https://github.com/mermaid-js/mermaid/blob/develop/packages/mermaid/src/docs/config/theming.md
            themeVariables: {
                primaryTextColor: SengiColors.sng_charcoal,//sng-charcoal
                primaryBorderColor: SengiColors.sng_veilchen,//sng-veillchen,
                lineColor: SengiColors.sng_flieder,//$sng-flieder,
                background: 'rgba(228,204,255,0.4)',
                fontFamily: 'arial',
                secondaryColor: '#2196f3',
                // edgeLabelBackground: '#fdccff',
            },
            themeCSS: `
            .node rect {
                fill: 'rgba(228,204,255,0.4)' !important;;
                stroke: ${SengiColors.sng_veilchen} !important;;
                stroke-width: 1px !important;;
            }
            `
         });

        mermaid.contentLoaded();
    },[]);

    return(
        <>
            <div id={id} className={`${componentClass ?? 'message-left-content'}`}>
                {items.map((x, index)  => (
                    <React.Fragment
                        key={`${x.type}-${x.position}-${index}`}
                    >
                        {   x.type === 'text'
                            ?   <div className={` my-1 ${textClass ?? ''}`}>
                                    <ReactMarkdown 
                                        remarkPlugins={[remarkMath,remarkEmoji,remarkGfm, remarkParse,remarkRehype,[remarkCollapse,{test:'heading'}]]} 
                                        rehypePlugins={[rehypeKatex,rehypeFormat,rehypeRaw, rehypeStringify]}
                                    >
                                            {x.element}
                                    </ReactMarkdown>
                                </div>
                            : x.type === 'image'
                                ?   <div className='row my-1 text-center'>
                                        <img 
                                            src={x.element} 
                                            alt={imageAltProp ?? 'Image'} 
                                            className={`${imageClass ?? 'rounded my-auto mx-auto d-block'}`}
                                            height={imageHeight ??''}
                                            width={imageWidth ?? ''}
                                            style={{height:'150px', width: 'auto'}}
                                        />
                                    </div>
                                : x.type === 'video'
                                    ?   <div className='text-center my-1' style={{width:'100%', aspectRatio: '10 / 4', paddingLeft:'10%', paddingRight:'10%'}}>
                                                <ReactPlayer 
                                                    url={x.element} 
                                                    height={videoHeight ?? '100%'}
                                                    width={videoWidth ?? '100%'}
                                                    controls={videoControlls ?? true}
                                                />
                                        </div>
                                    : x.type === 'code'
                                        ?   <div className='row my-1'>
                                                <div className='col'>
                                                    
                                                    <pre className={` my-1 bg-dark rounded ${codeStyleClass ?? ''}`}>
                                                        <div className='row p-1 me-3'>
                                                            <div className='col ms-2'>
                                                                {x.codeClass ?? ''}
                                                            </div>
                                                            <div className='col p-0'>
                                                                <div className='text-end'>
                                                                    <button
                                                                        type="button" 
                                                                        className="btn btn-chat border-0 bg-transparent text-light p-0 m-0" 
                                                                        data-bs-toggle="tooltip" 
                                                                        data-bs-placement="top" 
                                                                        title="Copy Code"
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            icon={faCopy}
                                                                            onClick={e => {
                                                                                navigator.clipboard.writeText(x.element);
                                                                                let copiedToast = document.getElementById("CopiedTextSuccesfull");
                                                                                if(!copiedToast) return;
                                                                                copiedToast.style.display = 'block';
                                                                                setTimeout(() => {
                                                                                if(copiedToast){
                                                                                    copiedToast.style.display = 'none';
                                                                                }
                                                                                }, 1000);
                                                                            }}
                                                                            size="1x"
                                                                            />
                                                                    </button>
                                                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <code className={x.codeClass ?? ''}>{x.element}</code>
                                                    </pre>
                                                </div>
                                            </div>
                                        : x.type === 'pdf'
                                            ? <div className='row my-1 text-center'>
                                                <div className='col'></div>
                                                <div className='col'>
                                                    <embed 
                                                        src={x.element} 
                                                        width={pdfWidth ?? '800px'} 
                                                        height={pdfHeight ?? '2100px'} 
                                                        style={{maxWidth:'fit-content'}}
                                                    />
                                                </div>
                                                <div className='col'></div>
                                            </div>
                                            : x.type === 'mermaid'
                                                 ? <> 
                                                        <div className={`mt-1 rounded-top ${codeStyleClass ?? ''}`} style={{background: SengiColors.sng_charcoal}}>
                                                            <div className='row p-1 me-3'>
                                                                <div className='col ms-2'>
                                                                    Mermaid
                                                                </div>
                                                                <div className='col p-0'>
                                                                    <div className='text-end'>
                                                                        <button
                                                                            type="button" 
                                                                            className="btn btn-chat border-0 bg-transparent text-light p-0 m-0" 
                                                                            data-bs-toggle="tooltip" 
                                                                            data-bs-placement="top" 
                                                                            title="Copy Code"
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                icon={faCopy}
                                                                                onClick={e => {
                                                                                    navigator.clipboard.writeText(x.element);
                                                                                    let copiedToast = document.getElementById("CopiedTextSuccesfull");
                                                                                    if(!copiedToast) return;
                                                                                    copiedToast.style.display = 'block';
                                                                                    setTimeout(() => {
                                                                                    if(copiedToast){
                                                                                        copiedToast.style.display = 'none';
                                                                                    }
                                                                                    }, 1000);
                                                                                }}
                                                                                size="1x"
                                                                                />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='text-center p-3 rounded-bottom' style={{background: SengiColors.sng_black}}>
                                                            <div className="mermaid">
                                                                {x.element}
                                                            </div>
                                                        </div>
                                                    </>
                                                : <></>
                        }
                    </React.Fragment>
                ))}
            </div>
        </>
    )
};